// store/useCompanyStore.js
import { setParsedHash } from "data/functions";
import { create } from "zustand";
import { persist } from "zustand/middleware";

const useAppStore = create(
  persist(
    (set, get) => ({
      error: false,
      loading: false,
    }),
    {
      name: "app-storage",
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key, value]) =>
              typeof value !== "function" &&
              key !== "cache" &&
              key !== "message" &&
              // key !== "customFontSize" &&
              !key.includes("doc") &&
              !key.includes("cache_"),
          ),
        ),
    },
  ),
);

export default useAppStore;
